import useTransferOffers from '@hooks/queries/registry/transfer/useTransferOffers';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundTransferOffers = () => {
  const { party } = useParties();

  const transfers = useTransferOffers();

  const filtered = (transfers?.data || []).filter((t) => t.payload.transfer?.receiver === party);
  return filtered;
};
